import { Form, Input } from 'antd';
import { MemberWrapper } from '../member-wrapper';
import { StepCompProps } from '../../add-member';
import cx from './index.module.scss';

const validName = (_, value) => {
  const zhCNPattern = new RegExp('[\u4E00-\u9FA5]+');
  if (!value?.trim()) {
    return Promise.reject('姓名/昵称不能为空');
  }
  // 限制长度：2~16个字符，一个汉字2个字符
  const len = Array.prototype.reduce.call<any, any[], number>(
    value,
    (accur, cur) => (zhCNPattern.test(cur) ? accur + 2 : accur + 1),
    0
  );
  if (len < 2 || len > 16) {
    return Promise.reject('姓名/昵称长度应为2~16个字符');
  }
  return Promise.resolve('');
};

const NameStep = (props: StepCompProps) => {
  const { hidden } = props;

  return (
    <div className={cx('wrapper')}>
      <Form.Item hidden={hidden} name="name" labelAlign="right" rules={[{ required: true, validator: validName }]}>
        <MemberWrapper title={'姓名/昵称'} rules={[{ required: true, validator: validName }]}>
          <Input placeholder="请输入姓名/昵称"  allowClear />
        </MemberWrapper>
      </Form.Item>
    </div>
  );
};

export { NameStep };
